import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Route, Router } from "react-router-dom";
import { logMsg } from "../common/Logger";
import Loading from "../shared/loading/Loading";
import NSCApp from "./NSCApp";
import AccessDeniedAsBevDisabled from "../components/accessDenied/AccessDeniedAsBevDisabled";
import CRCApp from "./CRCApp";
import POApp from "./POApp";
import DealerApp from "./DealerApp";
import { ADFS_TOKEN } from "../common/Constants";
import AuthenticationClient from "../shared/clients/AuthenticationClient";
import {
  AUTHORIZE_BASE_URL,
  ENV,
  ENTRA_ENABLE,
  SITE_ORIGIN,
} from "../utils/EmpUtil";
import {
  AUTHENTICATION_ERROR,
  AUTHENTICATION_METHOD_ERROR,
  displayError,
  is400,
  is500,
  PAGE_ERROR,
} from "../errors/ErrorConstants";
import { ofType } from "../common/PubSub";
import InvoiceApp from "./InvoiceApp";
import TeamAdminApp from "./TeamAdminApp";
import axios from "axios";

class App extends Component {
  static hideOrShow(show, setZIndex = false) {
    if (show) {
      App.loadingCount += 1;
      if (document.getElementById("loading"))
        document.getElementById("loading").style.display = "block";
      if (document.getElementById("appWrapper") && setZIndex) {
        document.getElementById("appWrapper").style.zIndex = "-1";
      }
    } else {
      if (App.loadingCount === 1) {
        if (document.getElementById("loading"))
          document.getElementById("loading").style.display = "none";
        if (
          document.getElementById("appWrapper") &&
          (document.getElementById("appWrapper").style.zIndex === "-1" ||
            document.getElementById("appWrapper").style.zIndex === -1)
        ) {
          document.getElementById("appWrapper").style.zIndex = "auto";
        }
      }
      if (App.loadingCount > 0) App.loadingCount -= 1;
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      renderApp: false,
      hasError: [],
      userDetails: null,
      fromNscDealerSearch: false,
      firstTimeLoadingApp: true,
    };

    App.loadingCount = 0;

    App.hideOrShow = App.hideOrShow.bind(this);
    this.updateUserDetails = this.updateUserDetails.bind(this);
    this.history = createBrowserHistory();
  }

  async componentDidMount() {
    App.hideOrShow(true);
    const authCode = this.getAuthCodeFromUrl();
    if (authCode) {
      await this.handleAuthCode(authCode);
    }

    // Handle the old token approach during migration to authCode approach.
    if (!authCode) {
      const accessTokenLegacy = this.getAccessTokenFromUrl();
      if (accessTokenLegacy) {
        logMsg(
          AUTHENTICATION_METHOD_ERROR +
            `: Authentication Method no longer supported.`
        );
        return this.setState({ hasError: [AUTHENTICATION_METHOD_ERROR] });
      }
    }
    const token = sessionStorage.getItem(ADFS_TOKEN);

    AuthenticationClient.status(token, {
      salesCode: null,
      page: null,
      brand: null,
    })
      .then((response) => {
        sessionStorage.setItem(ADFS_TOKEN, token);
        this.token = token;
        this.userDetails = response;
        sessionStorage.setItem("market", this.userDetails.market);
        this.userDetails.brand = "F";
        this.setState({ userDetails: this.userDetails });
        this.setState({ renderApp: true });
      })
      .catch((error) => {
        logMsg(error);
        if (is500(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        App.hideOrShow(false);
      });
    ofType("nscDealerSearch").subscribe((response) => {
      this.setState({
        fromNscDealerSearch: response.data,
      });
    });
  }

  async handleAuthCode(authCode) {
    try {
      const queryStringParams = this.createQueryStringParamsForTokenExchange();
      const tokenExchangeEndpoint = ENTRA_ENABLE
        ? "e-access-token-exchange"
        : "access-token-exchange";

      const res = await axios.post(
        `${AUTHORIZE_BASE_URL}/${tokenExchangeEndpoint}${queryStringParams}`,
        { authCode }
      );

      const token = res.data.access_token;
      sessionStorage.setItem(ADFS_TOKEN, token);
      window.location.href = SITE_ORIGIN;
    } catch (error) {
      // Do we need to show a pop-up saying authentication has failed?
      // Should we then redirect to ADFS to try again? Do we limit retries...?
      logMsg(error);
      if (is500(error) || is400(error)) {
        this.setState({ hasError: [AUTHENTICATION_ERROR] });
      }
      return;
    }
  }

  updateUserDetails(userDetails) {
    this.setState({ userDetails: userDetails });
  }

  getAuthCodeFromUrl() {
    try {
      if (!this.isStringInUrl("?")) {
        return null;
      }

      const queryString = window.location.href.split("?")[1];

      const queryParams = queryString.split("&");
      return this.findQueryParameterByName("code", queryParams);
    } catch (error) {
      return null;
    }
  }

  findQueryParameterByName(parameterName, queryParams) {
    let paramValue;

    queryParams.forEach((qp) => {
      if (paramValue) {
        return;
      }

      const keyValuePair = qp.split("=");
      if (keyValuePair[0].toLowerCase() === parameterName) {
        paramValue = keyValuePair[1];
      }
    });

    return paramValue;
  }

  getAccessTokenFromUrl() {
    try {
      if (!this.isStringInUrl("access_token")) {
        return null;
      }

      let queryStringParams = window.location.href.split("access_token=")[1];

      queryStringParams = "access_token=" + queryStringParams;
      const queryParams = queryStringParams.split("&");

      return this.findQueryParameterByName("access_token", queryParams);
    } catch (error) {
      return null;
    }
  }

  isStringInUrl(stringToFind) {
    return window.location.href.indexOf(stringToFind) > -1;
  }

  createQueryStringParamsForTokenExchange() {
    if (ENV === "local") {
      return "?localhost=true";
    }
    return "";
  }

  toggleFirstTimeLoadingApp = () => {
    this.setState({ firstTimeLoadingApp: false });
  };

  isNsc = (userDetails) => userDetails.userType === "nsc";

  isDealer = (userDetails) => userDetails.userType === "dealer";

  isCrc = (userDetails) => userDetails.userType === "crc";

  isPo = (userDetails) => userDetails.userType === "po";

  isTeamAdmin = (userDetails) => userDetails.userType === "teamAdmin";

  isInvoice = (userDetails) => userDetails.userType === "invoice";

  render() {
    if (displayError(this.state.hasError)) {
      throw new Error(this.state.hasError[0]);
    }

    return this.state.renderApp ? (
      <Router history={this.history}>
        <Loading brand={this.userDetails.brand} />
        <Route
          render={(props) => {
            if (this.isDealer(this.state.userDetails)) {
              return (
                <DealerApp
                  {...props}
                  token={this.token}
                  isNsc={false}
                  i18n={this.props.i18n}
                  userDetails={this.state.userDetails}
                  hideOrShow={App.hideOrShow}
                  fromNscDealerSearch={this.state.fromNscDealerSearch}
                  firstTimeLoadingApp={this.state.firstTimeLoadingApp}
                  toggleFirstTimeLoadingApp={this.toggleFirstTimeLoadingApp}
                  selectedMarket={this.state.userDetails.market}
                />
              );
            } else if (this.isNsc(this.state.userDetails)) {
              return (
                <NSCApp
                  {...props}
                  token={this.token}
                  isNsc={true}
                  i18n={this.props.i18n}
                  userDetails={this.state.userDetails}
                  hideOrShow={App.hideOrShow}
                  updateUserDetails={this.updateUserDetails}
                  fromNscDealerSearch={this.state.fromNscDealerSearch}
                />
              );
            } else if (this.isCrc(this.userDetails)) {
              return (
                <CRCApp
                  {...props}
                  token={this.token}
                  hideOrShow={App.hideOrShow}
                  i18n={this.props.i18n}
                  userDetails={this.state.userDetails}
                  updateUserDetails={this.updateUserDetails}
                  fromNscDealerSearch={this.state.fromNscDealerSearch}
                  selectedMarket={this.state.userDetails.market}
                  isCrc={true}
                />
              );
            } else if (this.isPo(this.userDetails)) {
              return (
                <POApp
                  {...props}
                  token={this.token}
                  i18n={this.props.i18n}
                  isPo={true}
                  userDetails={this.state.userDetails}
                  updateUserDetails={this.updateUserDetails}
                  fromNscDealerSearch={this.state.fromNscDealerSearch}
                  hideOrShow={App.hideOrShow}
                  selectedMarket={this.state.userDetails.market}
                />
              );
            } else if (this.isTeamAdmin(this.userDetails)) {
              return (
                <TeamAdminApp
                  {...props}
                  token={this.token}
                  i18n={this.props.i18n}
                  isPo={true}
                  userDetails={this.state.userDetails}
                  updateUserDetails={this.updateUserDetails}
                  fromNscDealerSearch={this.state.fromNscDealerSearch}
                  hideOrShow={App.hideOrShow}
                  selectedMarket={this.state.userDetails.market}
                />
              );
            } else if (this.isInvoice(this.userDetails)) {
              return (
                <InvoiceApp
                  {...props}
                  token={this.token}
                  i18n={this.props.i18n}
                  userDetails={this.state.userDetails}
                  hideOrShow={App.hideOrShow}
                  selectedMarket={this.state.userDetails.market}
                />
              );
            } else {
              if (document.getElementById("loading")) {
                return <AccessDeniedAsBevDisabled {...props} />;
              } else {
                return null;
              }
            }
          }}
        />
      </Router>
    ) : (
      <Loading />
    );
  }
}

export default App;
